import React from "react";
import { Box, Typography } from "@mui/material";

import OurProcessContainer from "./OurProcessContainer";

const OurProcess = () => {
  return (
    <Box
      sx={{
        py: "48px",
        px: "84px",
        "@media (max-width: 1200px)": {
          px: "24px",
        },
        "@media (max-width: 780px)": {
          px: "16px",
        },
      }}
    >
      <Typography
        variant="h2"
        component="h2"
        sx={{
          fontSize: "3rem",
          fontWeight: "bold",
          textAlign: "center",
          color: "#2A2177",
          mb: 2,
          "@media (max-width: 1200px)": {
            fontSize: "2.5rem",
          },
          "@media (max-width: 780px)": {
            fontSize: "2rem",
          },
        }}
      >
        Our Product-Agnostic Process
      </Typography>
      <Typography
        sx={{
          fontSize: "18px",
          fontWeight: "regular",
          textAlign: "center",
          color: "#666666",
          lineHeight: 1.7,
          mb: 5,
          "@media (max-width: 1200px)": {
            fontSize: "16px",
          },
        }}
      >
        We deliver measurable results that drive efficiency, improve workflows, and
        maximize the value of your digital assets across the organization.
      </Typography>

      <OurProcessContainer />
    </Box>
  );
};

export default OurProcess;
